import { render, staticRenderFns } from "./SearchTabUserForm.vue?vue&type=template&id=8b4c1fb8&scoped=true&"
import script from "./SearchTabUserForm.vue?vue&type=script&lang=js&"
export * from "./SearchTabUserForm.vue?vue&type=script&lang=js&"
import style0 from "./SearchTabUserForm.vue?vue&type=style&index=0&id=8b4c1fb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4c1fb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})
